import data from "../../.sourceflow/jobs.json";
import CollectionHelper from "@/helpers/CollectionHelper";

class JobsCollectionHelper extends CollectionHelper {
  fetch({
    limit = null,
    featured = null,
    sector = null,
    speciality = null,
    group = null,
    branch = null,
    exclude = null,
    filter = null,
  } = {}) {
    let items = this.collection.getItems();

    if (filter) {
      items = items.filter(filter);
    }

    if (sector) {
      if (Array.isArray(sector)) {
        items = items.filter((i) => sector.some((s) => JSON.stringify(i.categories).includes(s)));
      } else {
        items = items.filter((i) => JSON.stringify(i.categories).includes(sector));
      }
    }

    if (speciality) {
      if (Array.isArray(speciality)) {
        items = items.filter((i) => speciality.some((s) => JSON.stringify(i.categories).includes(s)));
      } else {
        items = items.filter((i) => JSON.stringify(i.categories).includes(speciality));
      }
    }

    if (group) {
      if (Array.isArray(group)) {
        items = items.filter((i) => group.some((g) => JSON.stringify(i.categories).includes(g)));
      } else {
        items = items.filter((i) => JSON.stringify(i.categories).includes(group));
      }
    }

    if (branch) {
      if (Array.isArray(branch)) {
        items = items.filter((i) => branch.some((b) => JSON.stringify(i.categories).includes(b)));
      } else {
        items = items.filter((i) => JSON.stringify(i.categories).includes(branch));
      }
    }

    if (featured) {
      items = items.filter((i) => i.featured === featured);
    }

    if (exclude) {
      items = items.filter((i) => !exclude.includes(i.id));
    }

    if (limit) {
      items = items.slice(0, limit);
    }

    return items;
  }
  getCategoryValues(search, { categories }) {
    const category = categories.find((i) => i.id === search || i.name === search);

    if (!category) {
      return [];
    }

    return category.values;
  }

  getCategoryValueIds(search, { categories }) {
    return this.getCategoryValues(search, { categories }).map((i) => i.id);
  }
}

export const jobs_helper = new JobsCollectionHelper(data.jobs);
